/*
 *
 *  remotes
 *
 */

import api from "../../helpers";

/**
 *
 * @param {string} metaData
 * @returns
 */
export function loadRecordsMetaData(metaData, method, payload) {
  if (method === "post") {
    return api
      .post(`/masters/${metaData}`, payload)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error));
  } else {
    return api
      .get(`/masters/${metaData}`, payload)
      .then((response) => response.data)
      .catch((error) => Promise.reject(error));
  }
}

export async function loadPaymentOutDetails(paymentDetails) {
  return await api
    .post(`/org/getpaymentout`, paymentDetails)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadPaymentOutReportDetails(paymentDetails) {
  return await api
    .post(`/org/paymentoutreports`, paymentDetails)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function createPaymentOutDetails(paymentDetails) {
  return await api
    .post(`/org/createpaymentout`, paymentDetails)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function loadPaymentSettledDetails(paymentDetails) {
  return await api
    .post(`/org/getsettlepurchaseinvoice`, paymentDetails)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

export async function updatePaymentOutDetails(paymentDetails) {
  return await api
    .put(`/org/editpaymentout`, paymentDetails)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}
export async function deletePaymentOutDetails(paymentDetails) {
  return await api
    .post(`/org/deletepaymentout`, paymentDetails)
    .then((response) => response.data)
    .catch((error) => Promise.reject(error));
}

const remotes = {
  loadPaymentOutDetails,
  createPaymentOutDetails,
  loadRecordsMetaData,
  updatePaymentOutDetails,
  deletePaymentOutDetails,
  loadPaymentSettledDetails,
  loadPaymentOutReportDetails,
};

export default remotes;
